import { Layout } from "antd";
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import MenuNew from "../../components/pages/MenuNew";
import ServicesNew from "../../components/pages/ServicesNew";

import { Orders } from "../../components/pages/Orders";
import { Reservations } from "../../components/pages/Reservations";
import EditProduct from "../../components/pages/EditProduct";
import { EditProductContextProvider } from "../../contexts/edit-product-context/EditProductContextProvider";
import { OrderPreview } from "../../components/pages/OrderPreview";
import { Marketing } from "../../components/pages/Marketing";
import { Settings } from "../../components/pages/Settings";
import { Coupons } from "../../components/pages/Coupons";
import { Stats } from "../../components/pages/Stats";
import { useBranchContext } from "../../contexts/branch-context";
import { OnlineSalesWarningBanner } from "../../components/molecules/online-sales-warning-banner/OnlineSalesWarningBanner";

export const MainContent: React.FC = () => {
  const { isSwitching } = useBranchContext();

  return (
    <Layout.Content
      style={{
        minHeight: "100%",
        position: "relative",
      }}
    >
      {/* Branch switching overlay */}
      {isSwitching && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            zIndex: 9999,
            pointerEvents: "all",
            cursor: "wait",
          }}
        />
      )}

      <OnlineSalesWarningBanner />

      <div
        style={{
          opacity: isSwitching ? 0.3 : 1,
          transition: "opacity 0.3s ease",
          pointerEvents: isSwitching ? "none" : "auto",
        }}
      >
        <Routes>
          <Route path="/check-order/:id" element={<OrderPreview />} />
          <Route path="/" element={<Navigate to="/orders" replace />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/reservations" element={<Reservations />} />
          <Route
            path="/menu"
            element={<MenuNew />}
          />
          <Route path="/services" element={<ServicesNew />} />
          <Route
            path="/edit-product/:productID"
            element={
              <EditProductContextProvider>
                <EditProduct />
              </EditProductContextProvider>
            }
          />
          <Route path="/marketing" element={<Marketing />} />
          <Route path="/loyalty" element={<Navigate to="/marketing" replace />} />
          <Route path="/stats" element={<Stats />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </div>
    </Layout.Content>
  );
};
